export const GET_BRAND_LIFT_REJECT_REASONS = 'GET_BRAND_LIFT_REJECT_REASONS';
export type GET_BRAND_LIFT_REJECT_REASONS = typeof GET_BRAND_LIFT_REJECT_REASONS;

export interface GetBrandLiftRejectReasons {
    type: GET_BRAND_LIFT_REJECT_REASONS;
    reasonsIds: string[];
    surveyId: string;
}

export function getBrandLiftRejectReasons(reasonsIds: string[], surveyId: string): GetBrandLiftRejectReasons {
    return {
        type: GET_BRAND_LIFT_REJECT_REASONS,
        reasonsIds,
        surveyId
    };
}

export const SET_BRAND_LIFT_REJECT_REASONS = 'SET_BRAND_LIFT_REJECT_REASONS';
export type SET_BRAND_LIFT_REJECT_REASONS = typeof SET_BRAND_LIFT_REJECT_REASONS;

export interface SetBrandLiftRejectReasons {
    type: SET_BRAND_LIFT_REJECT_REASONS;
    reasons: string[];
    surveyId: string;
}

export function setBrandLiftRejectReasons(reasons: string[], surveyId: string): SetBrandLiftRejectReasons {
    return {
        type: SET_BRAND_LIFT_REJECT_REASONS,
        reasons,
        surveyId
    };
}

export const DELETE_BRAND_LIFT_SURVEY = 'DELETE_BRAND_LIFT_SURVEY';
export type DELETE_BRAND_LIFT_SURVEY = typeof DELETE_BRAND_LIFT_SURVEY;

export interface DeleteBrandLiftSurveyAction {
    type: DELETE_BRAND_LIFT_SURVEY;
    campaignIds: string[];
}

export function deleteBrandLiftSurvey(campaignIds: string[]): DeleteBrandLiftSurveyAction {
    return {
        type: DELETE_BRAND_LIFT_SURVEY,
        campaignIds
    };
}

export const DELETE_BRAND_LIFT_STATUS = 'DELETE_BRAND_LIFT_STATUS';
export type DELETE_BRAND_LIFT_STATUS = typeof DELETE_BRAND_LIFT_STATUS;

export interface DeleteBrandLiftStatusAction {
    type: DELETE_BRAND_LIFT_STATUS;
    campaignIds: string[];
}

export function deleteBrandLiftStatusAction(campaignIds: string[]): DeleteBrandLiftStatusAction {
    return {
        type: DELETE_BRAND_LIFT_STATUS,
        campaignIds
    };
}

export type BrandLiftActions =
    | GetBrandLiftRejectReasons
    | DeleteBrandLiftSurveyAction
    | DeleteBrandLiftStatusAction
    | SetBrandLiftRejectReasons;
